import React, { useEffect, useState } from 'react';
import '../css/navBar.css';
import '../css/registro.css';
import logoFiltro from '../assets/Filter.png';
import mesaEmpresa from '../assets/mesa.png';
import { arreglarReloj, handleError, imprimirSeccion, toastError, toastSuccess } from '../funciones';
import axios from '../axiosConfig';
import { TablaN } from './TablaN';
import { ImprimirEmpresasInscriptas } from './ImprimirEmpresasInscriptas';
import { FiltrosAdmin } from './FiltrosAdmin';
import logoAsistencia from '../assets/asistencia.png';
import cruzCierre from '../assets/cruzBlanca.png';
import { AdminUserModals } from './AdminUserModals';
import { useAdminUsers } from '../hooks/useAdminUsers';
import { ViewProfileCompany } from './ViewProfileCompany';
import { useInscriptionsQuery } from '../hooks/useInscriptionsQuery';
import { BooleanToggleActions } from './BooleanToggleActions';
import { useAnimatedMount } from '../hooks/useAnimatedMount';

export const EmpresasInscriptas = ({ evento, funciones, nombreBuscar, show }) => {

    const [asistencia, setAsistencia] = useState('0');
    const [mostrarAsistencia, setMostrarAsistencia] = useState(false);
    const [loadingMap, setLoadingMap] = useState({});
    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
    const { mounted, visible } = useAnimatedMount(show);

    const getKey = (id, type) => `${id}-${type}`;

    const itemsFiltro = [
        {
            setValue: setAsistencia, value: asistencia, id: "asistencia", text: "Tipo de asistencia",
            items: ["Todas", "Pendientes", "Asistieron", "No asistieron"]
        }
    ];

    const { companies, loading, updateInscription, updateCompany } = useInscriptionsQuery({
        url: "empresa/verEmpresasDeUnEvento",
        params: { eventoId: evento?.id },
        enabled: !!evento?.id
    });

    useEffect(() => {
        if (show) funciones.updateHandlerRef.current = updateCompany;
    }, [updateCompany, show]);

    const selectedCompany = companies?.find(
        c => c.empresaPerfilFullView.id === selectedCompanyId
    )?.empresaPerfilFullView;

    useEffect(() => {
        selectedCompany && show && funciones.setSelectedCompany(selectedCompany)
    }, [selectedCompany])

    const mostrarEmpresa = (elem) => {
        var nombreAprobado = true
        if (nombreBuscar.localeCompare("") !== 0 && !elem.empresaPerfilFullView.nombre.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
            .includes(nombreBuscar.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")))
            nombreAprobado = false
        return (asistencia === "0" || (asistencia === "1" && elem.inscripcionView.asistio === null)
            || (asistencia === "2" && elem.inscripcionView.asistio) ||
            (asistencia === "3" && elem.inscripcionView.asistio === false)) && nombreAprobado
    }

    const contenidoFila = (elem) => {
        return <>

            <div className='col'>
                {elem.empresaPerfilFullView.nombre}
            </div>
            {evento.aprobarEmpresas && <div className='col-3 text-center'>
                {elem.inscripcionView.aprobada ? 'Aprobado' : elem.inscripcionView.aprobada === false ? 'Desaprobado' : 'Pendiente'}
            </div>}
            <div className='col-3 text-end align-items-center justify-content-end  d-flex'>
                {evento.aprobarEmpresas &&
                    <BooleanToggleActions
                        value={elem.inscripcionView.aprobada}
                        loading={isLoading(elem.inscripcionView.id, "aprobacion")}
                        onTrue={() => cambiarAprobacion(elem.inscripcionView.id, true)}
                        onFalse={() => cambiarAprobacion(elem.inscripcionView.id, false)}
                    />
                }

                {evento.permiteReuniones && evento.poseeMesasReservadas &&
                    <div className='ms-3  cursor-pointer containerBtnMesaFija' onClick={() => ponerMesaFija(elem)} data-bs-target="#modalMesaFija" data-bs-toggle="modal">
                        {elem.inscripcionView.numeroDeMesaReservada && <span className='d-block text-center numeroMesaFija'>{elem.inscripcionView.numeroDeMesaReservada}</span>}
                        <img id={"mesaFija"} className=' img-blanco-mobile' src={mesaEmpresa} alt="" />
                    </div>
                }


                <ViewProfileCompany companyId={elem.empresaPerfilFullView.id} onSelect={setSelectedCompanyId} />
            </div>
            <div className={`col-6 d-flex  px-0 columnaAsistencia h-100 ${mostrarAsistencia ? 'mostrar' : ''}`}>
                <div className='col-6 text-center align-self-center'>
                    {elem.inscripcionView.asistio ? 'Presente' : elem.inscripcionView.asistio === false ? 'Ausente' : 'Pendiente'}
                </div>
                <div className='col-6 text-end align-items-center justify-content-end pe-3  d-flex'>
                    <BooleanToggleActions
                        value={elem.inscripcionView.asistio}
                        loading={isLoading(elem.inscripcionView.id, "aprobacion")}
                        onTrue={() => cambiarAsistencia(elem.inscripcionView.id, true)}
                        onFalse={() => cambiarAsistencia(elem.inscripcionView.id, false)}
                    />
                    <ViewProfileCompany companyId={elem.empresaPerfilFullView.id} onSelect={setSelectedCompanyId} />
                </div>
            </div>
        </>
    }

    const setLoading = (id, type, value) => {
        const key = getKey(id, type);

        setLoadingMap(prev => ({
            ...prev,
            [key]: value
        }));
    }

    function isLoading(id, type) {
        return !!loadingMap[getKey(id, type)];
    }

    const cambiarAprobacion = (id, aprobado) => {
        setLoading(id, "aprobacion", true);

        const params = {
            params: {
                inscripcionId: id,
                aprobar: aprobado
            }
        }
        axios
            .put(process.env.REACT_APP_URL + "inscripcion/cambiarEstadoAprobacion", null, params)
            .then((res) => {
                updateInscription(id, { aprobada: aprobado });
                toastSuccess(aprobado ? "Aprobación registrada" : "Desaprobación registrada")

            })
            .catch(function (error) {
                toastError(handleError(error))
            })
            .finally(() => {
                setLoading(id, "aprobacion", false);
            });
    }

    const cambiarAsistencia = (id, asistio) => {
        setLoading(id, "asistencia", true);

        const params = {
            params: {
                inscripcionId: id,
                asistio: asistio
            }
        }
        axios
            .put(process.env.REACT_APP_URL + "inscripcion/registrarAsistencia", null, params)
            .then((res) => {
                updateInscription(id, { asistio: asistio });
                toastSuccess(asistio ? "Asistencia registrada" : "Ausencia registrada")
            })
            .catch(function (error) {
                toastError(handleError(error))
            })
            .finally(() => {
                setLoading(id, "asistencia", false);
            });
    }

    const ponerMesaFija = (ins) => {
        funciones.setInscripcion(ins.inscripcionView);
        funciones.setEmpresa(ins.empresaPerfilFullView);
    }

    const mostrarFiltros = () => {
        document.getElementById("containerFiltros").classList.remove("ocultarFiltros")
        document.getElementById("filtroOverlay").classList.remove("ocultarFiltros")
    }

    return (
        <>
            {mounted && <>

                <TablaN elementos={companies} id={'containerInscriptos'} classNameTabla={visible ? "transform-none" : ''}
                    itemsEncabezado={[{ className: 'col', text: 'Empresas inscriptas' },
                    { className: evento.aprobarInvitados && 'col-3 text-center', text: evento.aprobarInvitados && 'Estado' },
                    { className: 'col-3', text: '' },
                    {
                        className: 'position-absolute end-0 w-fit-content centrarContainer',
                        text: <>
                            <img src={logoFiltro} className='cursor-pointer me-3 mobile-white d-inline-block' alt="" onClick={mostrarFiltros} />
                            <img src={logoAsistencia} className='cursor-pointer me-3 mobile-white d-inline-block' alt="" onClick={() => setMostrarAsistencia(!mostrarAsistencia)} />
                            <div className='logoImprimir me-2 logoImprimirEmpresasInscriptas d-inline-block' alt=""
                                onClick={() => imprimirSeccion({
                                    idSeccion: "imprimirEmpresasInscriptas"
                                })} />
                        </>
                    }, {
                        className: `col-6 columnaAsistencia header h-100 px-0 ${mostrarAsistencia ? 'mostrar' : ''}`,
                        text: <div className='d-flex w-100 py-3 headerRowAsistencia'>
                            <div className='col-6 text-center'>Asistencia</div>
                            <div className='col-6 text-end'>
                                <img src={logoFiltro} className='cursor-pointer me-3 mobile-white d-inline-block' alt="" onClick={mostrarFiltros} />
                                <img src={cruzCierre} className='cursor-pointer me-3 mobile-white d-inline-block imgBlack' alt="" onClick={() => setMostrarAsistencia(!mostrarAsistencia)} />
                            </div>
                        </div>
                    }]}
                    itemsFilas={contenidoFila} elemNoEncontrado={'empresas'}
                    mostrarElem={mostrarEmpresa} mostrarLoader={loading} />
                <FiltrosAdmin itemsFiltro={itemsFiltro} />
                <ImprimirEmpresasInscriptas evento={evento} empresas={companies.map(elemento => elemento.empresaPerfilFullView)} />
            </>
            }
        </>
    );
}
